import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '@core/services/apis';
import { LocalStorageService } from '@core/services/common';
import { LOCAL_STORAGE_KEY } from '@core/configs';

@Injectable({
  providedIn: 'root'
})
export class CorpPrefixGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> {
    // const pathSegments = state.url.split('/');
    // const corpPrefix = pathSegments[1] || '';

    // if (pathSegments.includes(ROUTE_PATH.PAGE_NOT_FOUND)) {
    //   return of(false);
    // }

    // const localCorpPrefix =  this.sessionStorageService.getCorpPrefix();
    // if(!localCorpPrefix) {
    //   if(state.url.includes(TV.TV_URL)) this.authService.logout();
    //   else this.authService.logout();
    //   return of(false);
    // }
    // if (localCorpPrefix && localCorpPrefix == corpPrefix) {
    //   return of(true);
    // }
    
    const corpPrefix =  this.localStorageService.getItem(LOCAL_STORAGE_KEY.corpPrefix);

    // Gọi API kiểm tra corpPrefix hợp lệ hay không
    return this.authService.checkCorpPrefix(corpPrefix).pipe(
      map(res => {
        if (res.status == 200 && res?.result?.result) {
          return true;
        } else {
          this.authService.logout();
          return false;
        }
      })
    );
  }
}


